<template lang="pug">
div.ag-custom-cell.ag-cell-qty(
  :class='[invalidClass, infoMessage || warningMessage ? "info-message" : ""]'
)
  div.ag-custom-cell-value {{ moneyValue }}
  | &nbsp;&nbsp;
  i.far.fa-info-circle.info-icon(v-if='infoMessage && !totalsRow' :title='infoMessage')
  i.fas.fa-exclamation-circle.info-icon.error-icon(
    v-if='warningMessage'
    v-tooltip='validationMessage'
  )
</template>

<script>
/* eslint no-multi-spaces: 0 */
import Vue from 'vue'
import { isNullOrUndefined } from 'util'

// let instance = null

export default {
  data() {
    return {
      //
      noValue: false,
      invalidSum: false,
      validThreshold: true,
      validMinAmount: true,
      validMaxAmount: true
    }
  },

  computed: {
    //
    totalsRow() {
      return this.params.node.rowPinned === 'bottom'
    },

    infoMessage() {
      return this.params.colDef.infoMessage(this.params)
    },

    warningMessage() {
      return !this.validMinAmount || !this.validMaxAmount
    },

    moneyValue() {
      if (this.params.value === null) {
        this.noValue = true
        return null
      }

      const p = this.params
      const totals = [p.context.value || [], p.colDef.f, p.colDef.field]
      const isTotals = this.totalsRow && p.colDef.f

      const VALUE      = +p.value || (p.colDef.showDefaultEmpty ? '' : 0)
      let total = VALUE

      let sum = this.sum(...totals)
      this.invalidSum = p.colDef.validSum && p.colDef.validSum.value !== sum

      // TOTAL validations
      if (!isNullOrUndefined((p.colDef.minTotalThreshold || {}).value)) {
        this.validThreshold = p.colDef.minTotalThreshold.value <= sum
      }

      if (!isNullOrUndefined((p.colDef.maxTotalThreshold || {}).value)) {
        this.validThreshold = sum < p.colDef.maxTotalThreshold.value
      }

      // Line validations
      if (!isNullOrUndefined((p.colDef.minThreshold || {}).value) && !isTotals && p.value) {
        if (typeof this.minThreshold !== 'undefined') {
          if (this.minThreshold >= 0) {
            this.validMinAmount = (+this.minThreshold < +VALUE)
            this.strictMin = true
          } else {
            this.validMinAmount = (+this.minThreshold <= +VALUE)
          }
          //
          !this.validMinAmount ? this.notify() : this.nextNotification()
        } else {
          this.validMinAmount = true
        }
      }

      if (!isNullOrUndefined((p.colDef.maxThreshold || {}).value) && !isTotals && p.value) {
        if (typeof this.maxThreshold !== 'undefined') {
          if (this.maxThreshold > 0) {
            this.validMaxAmount = (+VALUE <= +this.maxThreshold)
          } else {
            this.validMaxAmount = (+VALUE < +this.maxThreshold)
            this.strictMax = true
          }
          //
          !this.validMaxAmount && this.notify()
          !this.validMaxAmount && !this.validMinAmount && this.nextNotification()
        } else {
          this.validMaxAmount = true
        }

        // when auto-correct needs to be implemented use next code:
        // if (!this.validMaxAmount) {
        //   // p.setValue(this.maxThreshold)
        //   // p.data._warning = true
        //   // return this.maxThreshold
        // } else {
        //   // p.data._warning = false
        // }
      }

      // set threshold flag
      if (isTotals) {
        p.context.totalsInvalid = !this.validThreshold
        this.validMinAmount = true
        this.validMaxAmount = true
      }

      return isTotals
              ? sum
              : total
    },

    invalidClass() {
      return {
        'invalid': this.invalidSum,
        'invalid-threshold': !this.validThreshold,
        'invalid-amount': !this.validMinAmount || !this.validMaxAmount
      }
    },

    skipConversion() {
      // return this.params.node.data._new && !this.params.node.data.draft
      // return this.params.node.data._new
    },

    currencyCode() {
      return this.params.colDef.currency || this.params.data && this.params.data.CurrencyCode || this.params.context.currency
    },

    validationMessage() {
      const column = this.params.colDef.alias || this.params.colDef.headerName
      let messageTemplateText = ''
      let strictMaxim = this.strictMax ? 'than' : 'than or equal to'
      let strictMinim = this.strictMin ? 'than' : 'than or equal to'

      if (!this.validMaxAmount) {
        messageTemplateText = `
            <p>
              ${column} must be less ${strictMaxim} <strong><v-money class="solid" currency='${this.currencyCode}'> ${this.maxThreshold} </v-money></strong>
            </p>
          `
      } else {
        if (!this.validMinAmount) {
          messageTemplateText = `
              <p>
                ${column} must be greater ${strictMinim} <strong><v-money class="solid" currency='${this.currencyCode}'> ${this.minThreshold} </v-money></strong>
              </p>
            `
        }
      }

      return messageTemplateText && this.currencyCode
        ? messageTemplateText
        : null
    }
  },

  created() {
    // instance = this
    this.setMinMaxAmountForValidation()
  },

  methods: {
    setMinMaxAmountForValidation() {
      this.cell = this.params.eGridCell
      this.gridRightMargin = this.params.api.gridPanel.ePinnedRightFloatingTop

      this.setMaxAmountForValidation()
      this.setMinAmountForValidation()

      if (this.maxThreshold < 0 &&
        typeof this.params.colDef.minThresholdRef[this.params.rowIndex] !== 'undefined' &&
        typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] !== 'undefined'
      ) {
        this.minThreshold = this.maxThreshold
        this.maxThreshold = 0

        this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.minThreshold
        this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.maxThreshold
      }
    },

    setMaxAmountForValidation() {
      // set max threshold for each cell in column
      this.params.colDef.maxThresholdRef = this.params.colDef.maxThresholdRef || []

      if (typeof this.params.data[this.params.colDef.field] !== 'undefined') {
        this.maxThreshold = typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] !== 'undefined' &&
          !isNaN(this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field])
          ? this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field]
          : (this.params.colDef.maxThreshold
            ? this.params.colDef.maxThreshold &&

              // compute max threshold based on formula / other column
              this.params.colDef.maxThreshold.f &&
              this.params.data[this.params.colDef.maxThreshold.f] ||

              // compute max threshold based on own value
              this.params.data[this.params.colDef.field] ||

              // max threshold specified on column definition
              this.params.colDef.maxThreshold.value ||

              // fallback to 0 max threshold
              0
            : null
          )

        if (typeof this.params.colDef.maxThresholdRef[this.params.rowIndex] === 'undefined') {
          this.params.colDef.maxThresholdRef[this.params.rowIndex] = {}
        }
        this.params.colDef.maxThresholdRef[this.params.rowIndex][this.params.colDef.field] = +this.maxThreshold
      }
    },

    setMinAmountForValidation() {
      // set min threshold for each cell in column
      this.params.colDef.minThresholdRef = this.params.colDef.minThresholdRef || []

      if (typeof this.params.data[this.params.colDef.field] !== 'undefined') {
        this.minThreshold = typeof this.params.colDef.minThresholdRef[this.params.rowIndex] !== 'undefined' &&
          !isNaN(this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field])
          ? this.params.colDef.minThresholdRef[this.params.rowIndex][this.params.colDef.field]
          : (this.params.colDef.minThreshold
            ? this.params.colDef.minThreshold &&

              // compute min threshold based on formula / other column
              this.params.colDef.minThreshold.f &&
              this.params.data[this.params.colDef.minThreshold.f] ||

              // min threshold specified on column definition
              this.params.colDef.minThreshold.value ||

              // fallback to 0 min threshold
              0
            : null
          )

        if (typeof this.params.colDef.minThresholdRef[this.params.rowIndex] === 'undefined') {
          this.params.colDef.minThresholdRef[this.params.rowIndex] = {}
        }
        this.params.colDef.minThresholdRef[this.params.rowIndex] = +this.minThreshold
      }
    },

    notify(forceShow) {
      //
    },

    notifyComponent(messageTemplateText, forceShow) {
      const id = `${this.params.colDef.field}-${this.params.rowIndex}`
      if (forceShow) {
        this.$notifications.showById(id)
      } else {
        this.$notifications.notify({
          id,
          type: 'plain',
          timeout: 0,
          allowDismiss: false,
          position: {
            position: 'absolute',
            left: `${this.gridRightMargin.getBoundingClientRect().left}px`,
            top: `${this.cell.getBoundingClientRect().top}px`,
            offsetTop: `${this.cell.parentNode.offsetTop + this.cell.clientHeight}px`
          },
          component: Vue.extend({
            template: messageTemplateText
          }),
          message: `${messageTemplateText} ${id}`,
          hide: this.$notifications.getLast().id !== id ? this.$notifications.errorState() : false
        })
      }
    },

    removeNotification(remove = true) {
      //
    },

    nextNotification() {
      //
    },

    getTaxes(item, field) {
      let sumTaxes = 0
      const taxes = item && item.taxes && item.taxes.length
                    ? item.taxes
                    : item && Object.keys(item).filter(k => ~k.indexOf('taxes_')).map(k => item[k]) || []

      if (taxes.length && field === 'total') {
        sumTaxes = taxes.reduce((taxes, tax) => taxes + (+tax.value || +tax || 0), 0)
      }

      return sumTaxes
    },

    getFees(item, field) {
      let sumFees = 0
      const fees = item && item.fees && item.fees.length
                    ? item.fees
                    : item && Object.keys(item).filter(k => ~k.indexOf('fees_')).map(k => item[k]) || []

      if (fees.length && field === 'total') {
        sumFees = fees.reduce((fees, fee) => fees + (+fee.value || +fee || 0), 0)
      }

      return sumFees
    },

    getDiscounts(item, field) {
      return item && item.discountAmount || 0
    },

    sum(items, formula, field) {
      // let _formula = formula.replace(/_(\d+)/g, '[$1].value')
      let _formula = formula

      if (this.params.context.total) {
        if (!isNaN(this.params.context.total)) {
          return parseFloat(parseFloat(this.params.context.total).toFixed(2))
        }
        return this.params.context.total
      }

      return parseFloat(items
              .map(data => data._skip ? 0 : +eval(_formula) + this.getTaxes(data, field) + this.getFees(data, field) - this.getDiscounts(data, field) || 0) // eslint-disable-line
              .reduce((a, b) => a + b, 0)
              .toFixed(2))
    },

    displayMoney(p) {
      return !(p.node.rowPinned === 'bottom' && !p.value && !p.colDef.f) && !this.noValue
    },

    showDetails() {
      this.shownDetails = !this.shownDetails
    },

    edit(v) {
      this.params.setValue(v.label)
      this.params.value = v.label
    },

    refresh() {
      //
      this.shownDetails = false
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.grid .ag-body-container .ag-row .ag-cell.ag-cell .ag-custom-cell {
  display: inline-block;
  &.ag-cell-qty.ag-cell-qty.ag-cell-qty.ag-cell-qty {
    display: block;
    text-align: right;
    .ag-custom-cell-value {
      display: inline-block;
      width: 80%;
      position: relative;
      left: -5px;
    }
  }

  .info-icon {
    font-size: $font-size-base-sm;
    @include theme {
      color: v(secondary-01);
    }
    cursor: pointer;

    &.error-icon {
      margin-right: -7px;
      margin-left: -5px;
      @include theme {
        color: v(urgent-01);
      }
    }
  }

  &.info-message .ag-custom-cell-value.ag-custom-cell-value {
    // display: inline-block;
    // width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/cells/qty.vue